
import { Injectable } from '@angular/core';
import { DLogger,DContextoMuiscaServicio } from '@dian/core';
import { Subject } from 'rxjs';
declare var require: (filename: string) => any;

var BigNumber = require('bignumber.js');

BigNumber.config({
    DECIMAL_PLACES: 2,
    EXPONENTIAL_AT: 100,
    FORMAT: {
        groupSize: 3,
        groupSeparator: ',',
        decimalSeparator: '.'
    }
});


export enum DTipoOperacionAritmetica {
    SUMA = <any>"SUMA",   
    RESTA = <any>"RESTA",
    MULTIPLICACION = <any>"MULTIPLICACION",
    DIVISION = <any>"DIVISION",
    DIVISION_ENTERA = <any>"DIVISION_ENTERA",  
    MODULO = <any>"MODULO",
    ES_CERO = <any>"ES_CERO",
    ABSOLUTO = <any>"ABSOLUTO",
    POTENCIA = <any>"POTENCIA",
    MAYOR_QUE = <any>"MAYOR_QUE",
    MAYOR_O_IGUAL_QUE = <any>"MAYOR_O_IGUAL_QUE",
    IGUALES = <any>"IGUALES",
    MENOR_QUE = <any>"MENOR_QUE",
    MENOR_O_IGUAL_QUE = <any>"MENOR_O_IGUAL_QUE"
}

@Injectable()
export class DOperacionesMatematicasServicio  {
    
    
    private menorValorRedondeo:number = 500;
    private mayorValorRedondeo:number = 1000;

    
    constructor(private dlogger:DLogger){}
    
    /**
     * @desc Funcion para obtener el número de una cadena que se encontraba en formato moneda
     * @param {String} valor
     * @return {String}
     */
    public deshacerFormatoMoneda(valor:string):string{
        if(!valor){
            return "0";
        }
        return valor.replace(/,/g, '');
    }
    
    /**
     * @desc Funcion para obtener el formato moneda de un valor
     * @param {String} valor
     * @return {String}
     */
    public obtenerFormatoMoneda(valor:string):string{
        valor = this.deshacerFormatoMoneda(valor);
        if(this.validarValorNumerico(valor)){
            let valorBigNumber = new BigNumber(valor);
            return valorBigNumber.toFormat();
        }else{
            return "0";
        }            
    }
    
    /**
     * @desc Funcion para obtener solo los números de una cadena
     * @param {String} valor
     * @return {String}
     */
    public obtenerSoloNumeros(valor:string):string{
        return valor.replace(/\D/g, '');
    }
    
    /**
     * @desc Funcion para validar si el valor numerico es correcto
     * @param {String} valor
     * @return {boolean}
     */
    public validarValorNumerico(valor:string):boolean{
        try{
            valor = this.deshacerFormatoMoneda(valor);
            let valorBigNumber = new BigNumber(valor);
            return true;
        }catch(e){
            this.dlogger.error("El valor " + valor+ " no es un valor numerico correcto");
            return false;
        }
    }

    /**
     * @desc Funcion para redondear un valor y convertirlo si se desea a un formato moneda
     * @param {String} valor
     * @param {boolean} formatearResultado   
     * @return {String}
     */
    public redondearValorMoneda(valor:string,formatearResultado?:boolean): string {
        
        this.dlogger.debug("Valor inicial: " + valor);
        valor = this.deshacerFormatoMoneda(valor);
        let valorBigNumber;
        let valorRedondeado;
        if(!this.validarValorNumerico(valor)) {
            return "0";
        }            
        
        valorBigNumber = new BigNumber(valor);                                            
        valorBigNumber=valorBigNumber.round();
        let valorModulo = valorBigNumber.modulo(this.mayorValorRedondeo);
        this.dlogger.debug("Valor Modulo:" + valorModulo.toString());
        let valorBigNumberMenor = valorBigNumber.plus(-valorModulo);
        if(valorModulo >= this.menorValorRedondeo && valorModulo < this.mayorValorRedondeo){
            valorRedondeado = valorBigNumberMenor.plus(1000);
        }else{
            valorRedondeado = valorBigNumberMenor;
        } 
        
        if(formatearResultado){
            this.dlogger.debug("Valor Redondeado con Formato:" + valorRedondeado.toFormat());
            return valorRedondeado.toFormat();
        }else{
            this.dlogger.debug("Valor Redondeado:" + valorRedondeado.toString());
            return valorRedondeado.toString();
        }
              
    } 
    
    /**
     * @desc Funcion para realizar una operacion matematica con dos valores
     * @param {DTipoOperacionAritmetica} operacion
     * @param {String} valor1
     * @param {String} valor2
     * @param {boolean} formatearResultado     
     * @return {String}
     */
    public ejecutarOperacion(operacion:DTipoOperacionAritmetica,valor1:string,valor2?:string,formatearResultado?:boolean):string{
        let valores = new Array<string>();
        valores[0]=valor1;
        valores[1]=valor2;
        return this.ejecutarOperacionMultipleValores(valores,operacion,formatearResultado);
    }
    
    /**
     * @desc Funcion para realizar una operacion matematica con un array que contenga multiples valores
     * @param {Array<String>} valores
     * @param {DTipoOperacionAritmetica} operacion     
     * @param {boolean} formatearResultado     
     * @return {String}
     */
    public ejecutarOperacionMultipleValores(valores:string[],operacion:DTipoOperacionAritmetica,formatearResultado?:boolean):string{
        let valorOperacion; 
        
        for(let indice in valores){
            let valor = this.deshacerFormatoMoneda(valores[indice]);
            
            if(this.validarValorNumerico(valor)) {
                if(indice=='0'){
                    valorOperacion = new BigNumber(valor);
                }else{                    
                    switch(operacion){                    
                        case DTipoOperacionAritmetica.SUMA:                       
                            valorOperacion = valorOperacion.plus(valor); 
                            break;                    
                        case DTipoOperacionAritmetica.RESTA:
                            valorOperacion = valorOperacion.minus(valor); 
                            break;                    
                        case DTipoOperacionAritmetica.MULTIPLICACION:
                            valorOperacion = valorOperacion.times(valor); 
                            break;                    
                        case DTipoOperacionAritmetica.DIVISION:
                            valorOperacion = valorOperacion.div(valor); 
                            break;                        
                        case DTipoOperacionAritmetica.DIVISION_ENTERA:
                            valorOperacion = valorOperacion.divToInt(valor); 
                            break;
                        case DTipoOperacionAritmetica.ES_CERO:
                            valorOperacion = valorOperacion.isZero(); 
                            break;                
                        case DTipoOperacionAritmetica.ABSOLUTO:
                            valorOperacion = valorOperacion.abs(); 
                            break; 
                        case DTipoOperacionAritmetica.MODULO:                       
                            valorOperacion =valorOperacion.mod(valor);
                            break;                                    
                        case DTipoOperacionAritmetica.POTENCIA:
                            valorOperacion =  valorOperacion.pow(valor);
                            break;                 
                    }
                }
            }
        }
        
        if(formatearResultado){
            this.dlogger.debug("Valor Operacion con Formato:" + valorOperacion.toFormat());
            return valorOperacion.toFormat();
        }else{
            this.dlogger.debug("Valor Operacion:" + valorOperacion.toString());
            return valorOperacion.toString();
        }

    }

    /**
    * @desc Funcion para ejecutar las demas funciones que contiene la libreria BigNumber como: lt, gt, gte, lte, equals
    * @param {String} valor1
    * @param {String} valor2 (opcional si la funcion lo requiere)
    * @param {DTipoOperacionAritmetica} operacion a realizar
    * @param {String}
    */
    public validacionesNumericas(operacion:DTipoOperacionAritmetica, valor1:string, valor2:string):boolean{
        let valorOperacion;
        let valorNumerico = this.deshacerFormatoMoneda(valor1); 
        let valorNumerico2 = this.deshacerFormatoMoneda(valor2); 

        if(this.validarValorNumerico(valorNumerico)) {
            valorOperacion = new BigNumber(valorNumerico);
            switch(operacion){
                case DTipoOperacionAritmetica.MAYOR_QUE:
                    valorOperacion = this.validarValorNumerico(valorNumerico2) ? valorOperacion.gt(valorNumerico2) : 0;
                    break;
                case DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE:
                    valorOperacion = this.validarValorNumerico(valorNumerico2) ? valorOperacion.gte(valorNumerico2) : 0;
                    break;
                case DTipoOperacionAritmetica.IGUALES:
                    valorOperacion = this.validarValorNumerico(valorNumerico2) ? valorOperacion.equals(valorNumerico2) : 0;
                    break;
                case DTipoOperacionAritmetica.MENOR_QUE:
                    valorOperacion = this.validarValorNumerico(valorNumerico2) ? valorOperacion.lt(valorNumerico2) : 0;
                    break;
                case DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE:
                    valorOperacion = this.validarValorNumerico(valorNumerico2) ? valorOperacion.lte(valorNumerico2) : 0;
                    break;           
            }     
        }
        
        return valorOperacion;     
    }

}


// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/recibo-pago/src/servicios/doperaciones-matematicas.servicio.ts